import { render, staticRenderFns } from "./interesesb.vue?vue&type=template&id=964356aa"
import script from "./interesesb.vue?vue&type=script&lang=js"
export * from "./interesesb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports